import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FaixaDescargaCIF } from '../models/faixa-descarga-cif';

@Injectable({
  providedIn: 'root'
})
export class FaixaDescargaCifService {

  constructor(private http: HttpClient) { }

  salvar(faixaDescarga: FaixaDescargaCIF) {
      return this.http.post(globals.apiUrl + '/api/FaixaDescargaCIF/Salvar', faixaDescarga);
    }

    excluir(id) {
      return this.http.delete(globals.apiUrl + '/api/FaixaDescargaCIF/Excluir',
        { params: new HttpParams().set('id', id) });
    }

    consultarPorIdFreteFaixa(idFaixaDescarga) {
      return this.http.get<any>(globals.apiUrl + '/api/FaixaDescargaCIF/Buscar',
        { params: new HttpParams().set('id', idFaixaDescarga) });
    }

    consultarFaixas() {
      return this.http.get<FaixaDescargaCIF[]>(globals.apiUrl + '/api/FaixaDescargaCIF/Lista');
    }

    consultarUltimaFaixa() {
      return this.http.get<FaixaDescargaCIF>(globals.apiUrl + '/api/FaixaDescargaCIF/BuscarUltimaFaixa');
    }

    consultarComPaginacao(descri, paginaAtual, qtdRegistros, campoOrdenacao, asc_desc) {
      let parametros = new HttpParams()
        .set('pag', paginaAtual)
        .set('qt', qtdRegistros)
        .set('ordem', campoOrdenacao)
        .set('asc_desc', asc_desc)
        .set('descri', descri ? descri : '');

      return this.http.get<any>(globals.apiUrl + '/api/FaixaDescargaCIF/ListaPag',
        {
          params: parametros
        });
    }
}
